import {Component, inject, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {filter, tap} from 'rxjs/operators';
import {NavigationEnd, Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ApplicationService} from '../../services/application.service';
import {LoginComponent} from '../login/login.component';

@Component({
    selector: 'app-start',
    imports: [CommonModule, FormsModule],
    templateUrl: './start.component.html',
    styleUrls: ['./start.component.scss']
})
export class StartComponent implements OnInit {
  @Input() type: string;
  @Input() idFieldLabel: string;

  router = inject(Router);
  activeModal = inject(NgbActiveModal);
  applicationService = inject(ApplicationService);

  application_type: string;

  constructor(private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      tap(e => this.activeModal.close())
    ).subscribe();
  }

  public close(startInfo) {
    this.applicationService.loadApplication(this.type, false, startInfo).pipe(
      tap(() => this.activeModal.close())
    ).subscribe();
  }

  public login(type) {
    this.activeModal.close();
    const modalInstance = this.modalService.open(LoginComponent, {size: 'md', backdrop: 'static'});
    modalInstance.componentInstance.type = type;
    modalInstance.componentInstance.resume = false;
    modalInstance.componentInstance.idFieldLabel = this.idFieldLabel;
  };
}
